import {Photo} from '@/features/host/types'
import {useState, useEffect} from 'react'
import {Spinner} from '../spinner/Spinner'

export const ImageView = ({photo}: {photo: Photo}) => {
    const {optimizedUrls, url} = photo
    const [imageSrc, setImageSrc] = useState('')
    const [hasError, setHasError] = useState(false)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const resolutions = [
            {key: '1440p', width: 1440},
            {key: '1080p', width: 1080},
            {key: '720p', width: 720},
            {key: '480p', width: 480},
            {key: '360p', width: 360}
        ]

        const screenWidth = window.innerWidth
        let chosenUrl = null

        if (optimizedUrls?.length) {
            for (const res of resolutions) {
                if (screenWidth >= res.width && optimizedUrls[res.key]) {
                    chosenUrl = optimizedUrls[res.key]
                    break
                }
            }
        } else {
            chosenUrl = url
        }

        if (!chosenUrl && optimizedUrls['360p']) {
            chosenUrl = optimizedUrls['360p']
        }

        setImageSrc(chosenUrl || url)
    }, [optimizedUrls, url])

    const handleImageError = () => {
        console.error('Error loading image:', imageSrc)
        setHasError(true)
        setIsLoading(false)
    }

    const handleImageLoad = () => {
        setIsLoading(false)
    }

    const finalSrc = hasError ? url : imageSrc

    return (
        <>
            {isLoading && <Spinner />}
            <img
                src={finalSrc}
                alt="Image"
                onLoad={handleImageLoad}
                onError={handleImageError}
                style={isLoading ? {display: 'none'} : {}}
            />
        </>
    )
}
